import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { fetchData, getWebsiteId } from '../Assets/API/apiservices'
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from '../Config/Config'

// Lazy load heavy components
const HCarosel = lazy(() => import('../Component/Carosel/Carosel'))
const MissionVission = lazy(() => import('../Component/MV/MV'))
const HS = lazy(() => import('../Component/HS/HS'))
const ServicesCarosel = lazy(() =>
  import('../Component/Carosel/Services_Carosel')
)
const CourseOffering = lazy(() =>
  import('../Component/Course_Offering/Course_Offering')
)
const StudyWithUs = lazy(() =>
  import('../Component/Study_with_us/Study_with_us')
)

// --- AnimatedSection Component ---
const AnimatedSection = React.memo(({ children, animationProps }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.18,
    rootMargin: '50px 0px',
  })

  useEffect(() => {
    if (inView) controls.start('visible')
  }, [controls, inView])

  const defaultAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  }

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={animationProps || defaultAnimation}
    >
      {children}
    </motion.div>
  )
})

// --- Main Home Component ---
const Home = () => {
  const HSData = useMemo(
    () => ({
      tittle: 'How we Started',
      image: 'home/HS/HSImage.jpg',
      description:
        'Dr.B.R. Ambedkar Educational Institutions was started by Late. Sri G Venkataswamy Garu, former Union Minister, Govt. of India in the year 1973. These institutions are inaugurated by Sri V.V. Giri, by then Hon. President of India. Dr.B.R. Ambedkar Educational Institutions is nestled up throughout a 4 acre land in Baghlingampally, Hyderabad. Being in the heart of the city, it boasts of a huge campus, excellent infrastructure facilities and dedicated management and staff. The institutions group includes High School, Junior College, Degree College, Post-Graduate College, Law College and MBA College. Approximately, 3000 students in total are presently studying in the institutions. Apart from the academics, Dr. B.R. Ambedkar educational institutions excels in extra curricular activities too. We have one of the best National Cadet Corps (NCC) team, 3 NSS units. We have partnered with the esteemed Spotlight Cricket Academy which provides excellent cricket coaching for the age group 6 to 18 years.Dr.B.R. Ambedkar Degree College was started in the year 1973. It was granted Aid in the year 1977. Around 1100 students are studying in the degree college which offers courses including B.Com (general), B.com (computers), BSc (MPC), BSc (computers), B.Sc (electronics), BBA, BA (Journalism) and BA (EPP).',
    }),
    []
  )

  const LoadingPlaceholder = () => (
    <div
      style={{
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Loading...
    </div>
  )

  return (
    <section className="home-container">
      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <HCarosel pageName="home" />
        </Suspense>
      </AnimatedSection>

      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <StudyWithUs />
        </Suspense>
      </AnimatedSection>

      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <MissionVission pageName="home" />
        </Suspense>
      </AnimatedSection>

      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <HS HS_DATA={HSData} />
        </Suspense>
      </AnimatedSection>

      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <CourseOffering />
        </Suspense>
      </AnimatedSection>

      <AnimatedSection>
        <Suspense fallback={<LoadingPlaceholder />}>
          <ServicesCarosel />
        </Suspense>
      </AnimatedSection>
    </section>
  )
}

export default React.memo(Home)
